export default {
  ITEM: 'Item -> ID',
  ZONE: 'Location / Zone',
  CUR_QTY: 'Current Qty',
  NEW_QTY: 'Qty Change',
  REASON: 'Reason'
};
